"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmployeesResults = _ref => {
  let {
    employees,
    lang,
    translate
  } = _ref;
  const items = employees.map(el => {
    return {
      link: {
        original_url: `/node/${el.node}#${el.section}`,
        url: '',
        title: `${el.firstname} ${el.lastname}, ${el.section}`
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "downloads sia-padding-04-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.employees')), /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: items,
    lang: lang
  }));
};
var _default = exports.default = EmployeesResults;